<section class="hero">
  <div>
    <p class="eyebrow">Intelligence</p>
    <h1>Developer scorecard</h1>
  </div>
</section>

<section class="filter-bar">
  <div class="search-field">
    <input
      type="search"
      placeholder="Search by name, email, or org…"
      [ngModel]="search()"
      (ngModelChange)="search.set($event)"
      (keydown.enter)="applySearch()" />
    <button type="button" class="ghost-button" (click)="applySearch()">Search</button>
  </div>
</section>

@if (result(); as result) {
  @if (result.items.length) {
    <section class="panel">
      <div class="panel-head">
        <div>
          <p class="panel-kicker">Developers</p>
          <h2>{{ result.paging.totalCount }} developer{{ result.paging.totalCount === 1 ? '' : 's' }} in scope</h2>
        </div>
      </div>

      <div class="table-shell">
        <table>
          <thead>
            <tr>
              <th>Developer</th>
              <th class="sortable" (click)="sortBy$('pullRequestCount')">PRs
                @if (sortBy() === 'pullRequestCount') { <span class="sort-icon">{{ sortDirection() === 'asc' ? '↑' : '↓' }}</span> }
              </th>
              <th class="sortable" (click)="sortBy$('totalIssues')">Issues
                @if (sortBy() === 'totalIssues') { <span class="sort-icon">{{ sortDirection() === 'asc' ? '↑' : '↓' }}</span> }
              </th>
              <th class="sortable" (click)="sortBy$('avgIssuesPerPullRequest')">Avg / PR
                @if (sortBy() === 'avgIssuesPerPullRequest') { <span class="sort-icon">{{ sortDirection() === 'asc' ? '↑' : '↓' }}</span> }
              </th>
              <th class="sortable" (click)="sortBy$('blockRate')">Block Rate
                @if (sortBy() === 'blockRate') { <span class="sort-icon">{{ sortDirection() === 'asc' ? '↑' : '↓' }}</span> }
              </th>
              <th>Severity</th>
              <th>Top Category</th>
              <th>Trend</th>
              <th>Last Active</th>
            </tr>
          </thead>
          <tbody>
            @for (dev of result.items; track dev.id) {
              <tr>
                <td>
                  <div class="dev-cell">
                    <strong>{{ dev.displayName }}</strong>
                    <span class="dev-email">{{ dev.email }}</span>
                  </div>
                </td>
                <td>{{ dev.pullRequestCount }}</td>
                <td>{{ dev.totalIssues }}</td>
                <td>{{ dev.avgIssuesPerPullRequest | number:'1.1-2' }}</td>
                <td>
                  <span class="block-rate" [class.block-rate-high]="dev.blockRate > 20">
                    {{ dev.blockRate | number:'1.1-1' }}%
                  </span>
                </td>
                <td>
                  <span class="sev-chips">
                    @if (dev.severityBreakdown.high) {
                      <span class="sev-chip sev-high">H{{ dev.severityBreakdown.high }}</span>
                    }
                    @if (dev.severityBreakdown.medium) {
                      <span class="sev-chip sev-medium">M{{ dev.severityBreakdown.medium }}</span>
                    }
                    @if (dev.severityBreakdown.low) {
                      <span class="sev-chip sev-low">L{{ dev.severityBreakdown.low }}</span>
                    }
                  </span>
                </td>
                <td>
                  <span class="category-pill">{{ dev.mostCommonIssueCategory }}</span>
                </td>
                <td>
                  @if (dev.improvementTrend) {
                    <span class="trend-cell" [class]="trendClass(dev.improvementTrend.direction)">
                      @if (dev.improvementTrend.displayLabel) {
                        {{ dev.improvementTrend.displayLabel }}
                      } @else if (dev.improvementTrend.deltaPercent !== null) {
                        {{ trendIcon(dev.improvementTrend.direction) }}
                        {{ dev.improvementTrend.deltaPercent | number:'1.0-1' }}%
                      } @else {
                        {{ trendIcon(dev.improvementTrend.direction) }}
                      }
                    </span>
                  }
                </td>
                <td>{{ dev.latestReviewActivityAt | localDate:'date' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  } @else {
    <section class="state-card">
      <p>No developer activity found for the selected range.</p>
    </section>
  }
} @else if (loading()) {
  <section class="state-card">Loading developer intelligence…</section>
} @else if (error()) {
  <section class="state-card error">
    <p>{{ error() }}</p>
    <button type="button" class="state-button" (click)="load()">Try again</button>
  </section>
} @else {
  <section class="state-card">
    <p>No data returned for the selected range.</p>
  </section>
}
